module.exports = __webpack_public_path__ + "static/media/Home.797bdd76.svg";